import ADUH_LOGO from "_Mobile/assets/aduh/ADUH.png";
import SLIDE1 from "_Mobile/assets/aduh/slide1.png";
import CTA from "_Mobile/assets/aduh/aduh_CTA.png";
import { Link } from 'react-router-dom';
import MobileAduhAddress from "_Mobile/components/Aduh/Address";
import Slider from 'react-slick';
import "./style.css";

const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const MobileAduhPeralatan = () => (
  <div className="Aduh MobileAduhPeralatan">
    <div className="header">
      <Link to="/aduh">
        <img className="logo" src={ADUH_LOGO} alt="" />
      </Link>
      <div className="subtitle">Peralatan</div>
    </div>
    <Slider {...sliderSettings}>
      <img src={SLIDE1} alt="Warehouse storage" className="banner-bg" />
    </Slider>
    <p className="equipment">
      Ruang seluas 1000 kaki persegi,
      dengan&nbsp;AC, wifi, sofa, meja, kursi,
      toilet, sistem suara, proyektor, mikrofon,
      instrumen, set drum, set DJ,
      kulkas, kompor listrik.
    </p>
    <a aria-label="Chat on WhatsApp" href="https://wa.me/60283591" target="_blank" rel="noopener noreferrer">
      <div className="CTA_wrapper">
        <img className="CTA" src={CTA} alt="" />
      </div>
    </a>
    <MobileAduhAddress />
  </div>
);

export default MobileAduhPeralatan;